import { render, staticRenderFns } from "./ModalFormularioUnidade.vue?vue&type=template&id=cdc723e2&"
import script from "./ModalFormularioUnidade.vue?vue&type=script&lang=js&"
export * from "./ModalFormularioUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports